export default "__VITE_ASSET__CcJ7BmnS__"